import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogType } from '../models';
import { SabisNgxDialogComponent } from '../../sabis-dialog/dialog.component';
import { SabisButton2Component } from '../../sabis-button2/sabis-button2.component';

@Component({
    selector: 'sabis-ngx-notification-dialog',
    templateUrl: './notification-dialog.component.html',
    styleUrls: ['./notification-dialog.component.scss'],
    imports: [SabisNgxDialogComponent, SabisButton2Component]
})
export class SabisNgxNotificationDialogComponent {
  public title: string = 'Dialog Title';
  public type: 'notification' | 'alert' = 'notification';
  public messages: string[] = [];
  public buttons: ActionButton[] = [];

  private _receivedData: NotificationDialogArgs = null as any;


  constructor(
    public dialogRef: MatDialogRef<SabisNgxNotificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotificationDialogArgs
  ) {
    this._receivedData = data;
    this.title = data.title;
    this.type = data.type === DialogType.Alert ? 'alert' : 'notification';
    this.messages = (typeof data.messages === 'string') ? [data.messages] : data.messages;

    // set action buttons
    if (this._receivedData.confirmationData) {
      // add confirmation buttons
      this.buttons.push({ name: this._receivedData.confirmationData.confirmationButtonName, result: true });
      this.buttons.push({ name: this._receivedData.confirmationData.discardButtonName, result: false });
    }
    else {
      this.buttons.push({ name: 'Ok', result: true });
      this.buttons.push({ name: 'Ok', result: true, cssClass: 'sc-button-red' });
    }
  }

  public onActionButtonClick(button: ActionButton): void {
    this.dialogRef.close(button.result);
  }
}

export interface NotificationDialogArgs {
  title: string;
  messages: string | string[];
  type: DialogType;

  confirmationData?: null | {
    confirmationButtonName: string,
    discardButtonName: string
  }
}

interface ActionButton {
  result: boolean;
  name: string;
  cssClass?: string;
}
